// @format
import qs from 'qs'
import { createAxios, getBaseURL } from '../_utils'

export const serviceID = 'asset'
export const serviceDevHost = '192.168.1.22'
export const servicePort = 23888
export const serviceName = '资产'

export const _axios = createAxios(
  getBaseURL(serviceDevHost, servicePort, serviceID),
  {},
  serviceName
)

export default function() {
  return {
    houseAsset: {
      list(houseSpaceId, hasEmptyTypes) {
        return _axios.get(
          `houseAsset/list/${houseSpaceId}?` +
            qs.stringify({ has_empty_types: hasEmptyTypes })
        )
      },
      // http://192.168.1.22:23888/swagger-ui.html#!/house45asset45mapping45controller/updateUsingPOS
      update(houseAssetOpBeans) {
        return _axios.post('/houseAsset/update', { houseAssetOpBeans })
      },
    },

    // http://192.168.1.22:23888/swagger-ui.html#!/house45asset45mapping45controller/insertHouseAssetUsingPOST
    houseAssetOption: {
      list(typeId) {
        return _axios.get(`/houseAsset/showByTypeId/${typeId}`)
      },
    },
  }
}



// WEBPACK FOOTER //
// ./src/xhr/services/asset.js